(function () {
  const blogTabs = document.querySelector(".ts-blogs__tabs");
  const moreButtons = document.querySelectorAll(".ts-blogs__more");
  const paginateSize = 4;

  blogTabs.addEventListener("click", (e) => {
    if (e.target.hasAttribute("data-tab") && !e.target.classList.contains("active")) {
      const blogHandle = e.target.getAttribute("data-tab");
      document.querySelector(".ts-blogs__block-wrapper.active.animate").classList.remove("animate");
      setTimeout(() => {
        document.querySelector(".ts-blogs__block-wrapper.active").classList.remove("active");
        document.querySelector(".ts-blogs__tab.active").classList.remove("active");
        document.querySelector(`.ts-blogs__block-wrapper[data-tab="${blogHandle}"]`).classList.add("active");

        setTimeout(() => {
          document.querySelector(`.ts-blogs__block-wrapper[data-tab="${blogHandle}"]`).classList.add("animate");
          e.target.classList.add("active");
        }, 50)
      }, 350)
    }
  });

  moreButtons.forEach(more => {
    more.addEventListener("click", (e) => {
      const tab = e.target.closest(".ts-blogs__block-wrapper");
      const handle = tab.getAttribute("data-tab");

      if (handle == 'all') {
        const hiddenArticles = tab.querySelectorAll(".ts-blogs-article[hidden]");
        if (hiddenArticles.length > 0 && hiddenArticles.length < paginateSize) {
          hiddenArticles.forEach(article => {
            article.removeAttribute("hidden");
          });
          more.setAttribute("hidden", true);
        } else {
          for (let i = 0; i < paginateSize; i++) {
            hiddenArticles[i].removeAttribute("hidden");
          }
        }
      } else {
        const currentPage = parseInt(tab.getAttribute("data-current"));
        const pagesSize = parseInt(tab.getAttribute("data-pages"));

        more.classList.add("loading");
        fetch(`${window.location.origin + window.location.pathname}?page=${currentPage + 1}`)
          .then(response => response.text())
          .then(text => {
            const html = new DOMParser().parseFromString(text, "text/html");
            const newTab = html.querySelector(`.ts-blogs__block-wrapper[data-tab="${handle}`);
            const newArticles = newTab.querySelectorAll(".ts-blogs-article");
            newArticles.forEach(newArticle => {
              tab.querySelector(".ts-blogs__block").append(newArticle);
            });
            tab.setAttribute("data-current", currentPage + 1);

            if (currentPage + 1 === pagesSize) {
              more.setAttribute("hidden", true);
            } else {
              more.classList.remove("loading");
            }
          })
          .catch(error => console.error(error))
      }
    })
  })
})();